module.exports = __webpack_public_path__ + "static/media/Helga.f23c6f2c.png";